<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Admin />

        <div id="logout">
            <div class="content">
                <span>Vous allez être déconnecté et revenir à la page d'accueil du site Lock Quest...</span>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Admin from '../../components/HeaderMenu_Admin.vue';
import Footer from '../../components/Footer.vue';

export default {
    name: "Admin_LogoutPage",
    components: {
        HeaderMenu_Admin,
        Footer
    },
    mounted() {
        var self = this;
        setTimeout(function() {
            self.$store.dispatch('authentication/deleteToken').then(() => {
                self.$router.push({ name: 'site_homepage' }).catch((error) => { });
            }).catch((error) => {

            });
        }, 2000);
    }
};
</script>